import {
  SET_DOWNLOAD_POINTS_BOX_OPEN,
  DOWNLOAD_POINTS_PENDING,
  DOWNLOAD_POINTS_SUCCESS,
  DOWNLOAD_POINTS_FAILED,
  GET_POINT_VALUE_PENDING,
  GET_POINT_VALUE_SUCCESS,
  GET_POINT_VALUE_FAILED,
} from '../actionTypes'

const mapState = {
  isDownloadPointsBoxOpen: false,
  downloadPointsPending: false,
  downloadPointSuccess: false,
  downloadPointErrorMessage: null,
  getPointPending: false,
  point: null,
  getPointError: null,
}

const pointReducer = (state = mapState, { type = '', payload = {} }) => {
  switch (type) {
    case SET_DOWNLOAD_POINTS_BOX_OPEN: {
      return {
        ...state,
        isDownloadPointsBoxOpen: !state.isDownloadPointsBoxOpen,
      }
    }
    case DOWNLOAD_POINTS_PENDING: {
      return {
        ...state,
        downloadPointsPending: true,
        downloadPointSuccess: false,
      }
    }
    case DOWNLOAD_POINTS_SUCCESS: {
      return {
        ...state,
        downloadPointsPending: false,
        downloadPointSuccess: true,
      }
    }

    case DOWNLOAD_POINTS_FAILED: {
      return {
        ...state,
        savePointsPending: false,
        downloadPointErrorMessage: payload,
      }
    }

    case GET_POINT_VALUE_PENDING: {
      return {
        ...state,
        getPointPending: true,
      }
    }

    case GET_POINT_VALUE_SUCCESS: {
      return {
        ...state,
        point: payload,
        getPointPending: false,
      }
    }

    case GET_POINT_VALUE_FAILED: {
      return {
        ...state,
        getPointError: payload,
        getPointPending: false
      }
    }
    default:
      return state
  }
}

export default pointReducer